import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Toast } from 'antd-mobile';
import queryString from 'query-string';
import Http from '../../config/axiosUtils';
import Empty from '../../components/common/Empty';
import TeamCommon from '../../components/team/TeamCommon';
import GroupItem from '../../components/team/GroupItem';

import '../../assets/scss/Group/teamHome.scss';
import AvaterImg from '../../assets/images/group/team_avatar@2x.png';

class TeamHome extends Component {
  state = {
    teamStatus: [],
    currentIndex: '',
    topData: {},
    personData: {}, //个人数据
    teamData: {}, //团队数据
    referrerList: [] //团队成员
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const path = `/spread/web/team/referrer/account/info/${this.props.match.params.id}/${queryString.parse(this.props.location.search).code}`;
    const res = await Http.get(path);
    if (res.code === 0) {
      const arr = [];
      if (res.data.referrerAccountList !== null) {
        arr.push('团队成员');
      }
      arr.push('个人数据');
      if (res.data.teamData !== null) {
        arr.push('团队业绩');
      }
      this.setState({
        referrerList: res.data.referrerAccountList,
        teamData: res.data.teamData,
        personData: res.data.personData,
        topData: res.data.memberAoountInfoMO,
        teamStatus: arr,
        currentIndex: arr[0]
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  //点击title
  changeTeam = (item) => {
    this.setState({
      currentIndex: item
    })
  }
  

  render () {
    const { currentIndex, topData, referrerList, teamData, personData } = this.state;
    const { teamLevel } = queryString.parse(this.props.location.search);
    return (
      <div>
        <Helmet><title>队员详情</title></Helmet>
        <div className='teamHome'>
          <div className='team-top'>
            <div className='top-main'>
              <div className='top-main-avater'><img src={AvaterImg} alt='' /></div>
              <div className='top-main-info'>
                <div className='title'>
                  <span className='title-name'>{topData.name}</span>
                  {/* <span className='title-tag'>合伙人</span> */}
                  {topData.status === 0 && <span className='title-tag'>正常</span>}
                </div>
                <div className='mobile'>{topData.mobile}</div>
              </div>
            </div>
            <div className='top-detail'>
              <ul>
                {teamLevel === '1' && <li>
                  <div>团队成员</div>
                  <div>{topData.memberCount}人</div>
                </li>}
                <li className={teamLevel === '2' ? 'onlyOne' : ''}>
                  <div>加入日期</div>
                  <div>{topData.referrerTime}</div>
                </li>
              </ul>
            </div>
          </div>
          <div className='group-content'>
            <div className='content-bg'>
              <ul className='team-title'>
                {
                  this.state.teamStatus.map((item, index) => {
                    return (
                      <li
                        key={index}
                        className={currentIndex === item ? 'team-high' : ''}
                        onClick={this.changeTeam.bind(this, item)}>
                        {item}
                        {currentIndex === item && <i></i>}
                      </li>
                    )
                  })
                }
              </ul>
            </div>
            <div className={currentIndex !== '团队成员' ? 'team-data' : ''}>
              {currentIndex === '团队成员' && (referrerList.length < 1 ? <Empty tip='暂无数据' /> : <GroupItem groupList={referrerList}></GroupItem>)}
              {currentIndex === '个人数据' && (!personData ? <Empty tip='暂无数据' /> :
               (<>
               {/* <div style={{margin: '10px 0'}}>
                <Picker
                  extra='请选择'
                  data={this.state.litData}
                  cols={1}
                  value={this.state.type}
                  onChange={this.onChangeType}>
                  <List.Item arrow="horizontal"> 节点 </List.Item>
                </Picker>
              </div> */}
               <TeamCommon teamData={personData} isGroupHome></TeamCommon></>))}
              {currentIndex === '团队业绩' && (!teamData ? <Empty /> : <TeamCommon teamData={teamData} isGroupHome></TeamCommon>)}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TeamHome;
